














































import StudentParentInfoPage from '../../student/info/StudentParentInfoPage.vue';
import StudentInfoPage from '../../student/info/StudentInfoPage.vue';
import StudentCommunicationPage from '../../student/info/StudentCommunicationPage.vue';
import StudentEducationalEnvPage from '../../student/info/StudentEducationalEnvPage.vue';
import StudentPaymentPage from '../../student/info/StudentPaymentPage.vue';
import StudentOpportunityPage from '../../student/info/StudentOpportunityPage.vue';
// import StudentInputCofirmPage from '../../student/info/StudentInputCofirmPage.vue';
import RequiresAnnounce from '../../components/atoms/RequiresAnnounce.vue';

import { Vue, Component, Prop } from 'vue-property-decorator';
import { StudentInfoInputDTO } from '../../../src_server/entity/dto/StudentInfoInputDTO';
import { MessageDialog } from '../../../src_client/utils/MessageDialog';
import { StudentService } from '../../../src_client/biz/remote/StudentService';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { Session } from '../../utils/Session';

@Component({
  components: {
    StudentParentInfoPage,
    StudentInfoPage,
    StudentCommunicationPage,
    StudentEducationalEnvPage,
    StudentPaymentPage,
    StudentOpportunityPage,
    // StudentInputCofirmPage,
    RequiresAnnounce,
    CommonDialog,
  },
})
export default class StudnetInfoMaintenance extends Vue {
  @Prop({ default: false })
  forDisplay!: boolean;

  private info: StudentInfoInputDTO = new StudentInfoInputDTO();

  private iconImageFile?: File;

  private dialog_title = '';

  /**
   * 詳細ボタンのイベントハンドラ
   */
  public show(row: StudentInfoInputDTO) {
    this.info = row;
    this.dialog_title = `${row.userAuth.user_name}さんの情報`;
    const dialog = this.$refs['student_detail_dialog'] as CommonDialog;
    dialog.show();
  }
  public hide() {
    const dialog = this.$refs['student_detail_dialog'] as CommonDialog;
    dialog.hide();
  }

  async cancel() {
    this.$emit('cancel');
  }

  async logicalDelete() {
    const result = await MessageDialog.confirm('登録しますよろしいですか？');
    if (result) {
      const user_id = this.info.userAuth.user_id!;
      const biz = new StudentService();
      await biz.deleteStudent(user_id);
      await MessageDialog.alert(`ユーザーを削除しました。`);
      this.hide();
      this.$emit('delete-student', user_id);
    }
  }

  async register() {
    console.log(this.info);
    if (!this.info.userAuth.user_id) {
      await MessageDialog.systemError('ユーザーID', 'マスタメンテナンスユーザ情報登録時');
      return;
    }
    const result = await MessageDialog.confirm('登録しますよろしいですか？');
    if (result) {
      const biz = new StudentService();
      try {
        await biz.maintenanceUpdate(this.info.userAuth.user_id, Session.getSessionBuildingId(), this.info);
        this.hide();
        await MessageDialog.alert('登録完了しました');
      } catch (error) {
        await MessageDialog.alert(error);
      }
    }
  }
}
